module.exports = __webpack_public_path__ + "static/media/THAILAND-circle.1c9dfa4c.svg";